import { ActionReducerMap } from '@ngrx/store';
import * as fromForm from '../forms/state/reducers';


export interface AppState {
    forms: fromForm.FormsState
}

export const reducers: ActionReducerMap<any> = {
    forms: fromForm.reducers,
};



// WEBPACK FOOTER //
// ./src/app/reducers/index.ts